$(document).on('turbolinks:load', function() {
  $('.password-visibiliy-link').on('click', function(e) {
    e.preventDefault();
    let $input = $(this).parent().find('input');
    console.log($input)
    if($input.attr('type') == 'password') {
      $input.attr('type', 'text');
    } else {
      $input.attr('type', 'password');
    }

    $('.password-visibiliy-link').toggleClass('hidden');
  });

  $('.snackbar').each(function() {
    $(this).addClass('snackbar-opened');
    setTimeout(function() {
      $('.snackbar').removeClass('snackbar-opened');
    }, 10000);
  });

  $('.date-entry').on('blur', '.date-entry-fields input.month, .date-entry-fields input.day', function() {
    if($(this).val().length == 1) {

      $(this).val($(this).val().padStart(2, '0'));

    }
  });

  $('.date-entry').on('blur', '.date-entry-fields input.year', function() {
    if($(this).val().length == 2) {

      current_year = new Date().getFullYear().toString().substr(-2);
      year = parseInt($(this).val());

      if(year > current_year && $(this).attr('name') == 'birthday[year]') {
        $(this).val("19" + year);
      }
      else {
        $(this).val("20" + year);
      }
    }

  });

  $(document).on("input", ".date-entry-fields input", function() {

    $(this).val($(this).val().replace(/\D/g,''));

    if ($(this).hasClass('month') || $(this).hasClass('day')) {

      if ($(this).val().length > 2) {
        $(this).val($(this).val().substring(0, 2));
      }
    }

    if ($(this).hasClass('year')) {
      if ($(this).val().length > 4) {
        $(this).val($(this).val().substring(0, 4));
      }
    }

  });

});